import { useEffect, useReducer, useState } from "react";
import { Dialog, DialogTitle, Box, Tooltip, Button, DialogContent } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import './styles.css'
import api from "../../../../api";
import { lockedReducer } from "../../../../utils/defaultReducer";
import useNotification from "../../../Notification";
import Loading from "../../../Loading";
import { getSession } from "../../../../auth";
import dayjs from 'dayjs'

const funcoes = {
    asdate: (valor) => {
        return dayjs.utc(valor).local().format('DD/MM/YYYY HH:mm:ss')
    }
};

const resolveComFuncao = (obj, partes) => {
    let atual = obj;
    let caminho = [];

    for (let i = 0; i < partes.length; i++) {
        const parte = partes[i];

        // Se for uma função e o atual ainda existe
        if (i === partes.length - 1 && funcoes[parte] && atual !== undefined) {
            return funcoes[parte](atual);
        }

        caminho.push(parte);
        const tentativa = caminho.join(".");
        atual = tentativa.split('.').reduce((acc, key) => acc && acc[key], obj);

        // Se chegamos num valor undefined antes da função, paramos
        if (atual === undefined && i < partes.length - 1) return `[${tentativa} não encontrado]`;
    }

    return atual !== undefined ? atual : `[${caminho.join('.')} não encontrado]`;
}

const parseData = (data, info) => {
    return data.replace(/\{\{(.*?)\}\}/g, (_, chaveOriginal) => {
        const partes = chaveOriginal.split("__");
        return resolveComFuncao(info, partes);
    });
}


const CreateContact = ({ info }) => {
    const source = info.true_function
    return (
        <>
            {
                source?.description &&
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.25rem'}}>
                    <Box sx={{ marginBottom: '1rem', padding: '.5rem 0rem'  }}>{parseData(source?.description || '', info)}</Box>
                    {source.extra && <Box sx={{ whiteSpace: 'pre-line', padding: '.5rem 0rem'  }}>{parseData(source?.extra || '', info)}</Box>}
                    <ExpandJson data={info.request} />
                </Box>
            }
        </>
    )
}

const ShowContact = ({ info }) => {
    const source = info.true_function
    return (
        <>
            {
                source?.description &&
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.25rem'}}>
                    <Box sx={{ marginBottom: '1rem', padding: '.5rem 0rem'  }}>{parseData(source.description, info)}</Box>
                    <ExpandJson data={info.response} />
                </Box>
            }
        </>
    )
}

const UpdateContact = ({ info }) => {
    const source = info.true_function
    const request = Object.keys(info?.request || {})
    return (
        <>
            {
                source?.description &&
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
                    <Box sx={{ marginBottom: '1rem', padding: '.5rem 0rem' }}>{parseData(source.description, info)}</Box>
                    {source.compare &&
                        <Box sx={{ whiteSpace: 'pre-line' }}>
                            {request.flatMap((key) => {
                                if (!(info.lost[key] && info.response[key]) || info.lost[key] === info.response[key]) return []
                                return `${key}: ${info.lost[key] || "''"} → ${info.response[key] || "''"}\n`})}
                        </Box>
                    }
                    <ExpandJson data={{ 'requisição': info.request, 'antes': info.lost, 'depois': info.response }} />
                </Box>
            }
        </>
    )
}

const DeleteContact = ({ info }) => {
    const source = info.true_function
    return (
        <>
            {
                source?.description &&
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
                    <Box sx={{ marginBottom: '1rem', padding: '.5rem 0rem'}}>{parseData(source.description, info)}</Box>
                    <ExpandJson data={info.lost} />
                </Box>
            }
        </>
    )
}

const ExpandJson = ({ data }) => {
    const [show, setShow] = useState(false)
    return (
        <Box>
            {<Button variant="contained" fullWidth onClick={() => setShow(p => !p)}>{!show ? 'Mostrar' : 'Ocultar'} dados</Button>}
            {show && <Box className='expandedjson'>
                <pre style={{whiteSpace: 'pre-wrap'}}>{JSON.stringify(data, null, 2)}</pre>
            </Box>}
        </Box>
    )
}

const retrieveData = async (data, setState) => {
    const enterpriseId = getSession().profile.enterprise.id
    setState({ loading: true })
    const res = await api.get(`api/enterprises/${enterpriseId}/audit/${data.id}/`)
    if (res.status === 200) {
        setState({ info: res.data, loading: false })
    } else {
        setState({ loading: false })
        useNotification(
            "Ops",
            "Não foi possível recuperar os dados.",
            "danger"
        )
    }

}

const AuditInformation = ({ data, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        info: {},
        loading: false
    })

    useEffect(() => {
        retrieveData(data, setState)
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            <Dialog
                open={true}
                fullWidth
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle
                    id="customized-dialog-title" className={'group-flexbox'}>
                    <span>Informações adicionais</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button"  >
                            <CloseIcon onClick={handleClose} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <DialogContent className='piloto-modal-flex'>
                    <Box className='audit-flex-column'>
                        <Box>
                            <Box className='options-menu-title'>IP</Box>
                            <Box sx={{padding: '.5rem 0rem'}}>{state.info.ip}</Box>
                        </Box>
                        {state.info?.true_function && <Box>
                            <Box className='options-menu-title'>Informações</Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                {data.method === 'GET' && state.info && <ShowContact info={state.info} />}
                                {data.method === 'POST' && state.info && <CreateContact info={state.info} />}
                                {data.method === 'PATCH' && state.info && <UpdateContact info={state.info} />}
                                {data.method === 'DELETE' && state.info && <DeleteContact info={state.info} />}
                            </Box>
                        </Box>}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AuditInformation